import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-4 px-4" }
const _hoisted_2 = { class: "col-span-1" }
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = { class: "col-span-1" }
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "col-span-1" }
const _hoisted_7 = { class: "col-span-1" }
const _hoisted_8 = { class: "col-span-1" }
const _hoisted_9 = { class: "col-span-1" }
const _hoisted_10 = { class: "col-span-1" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = { class: "col-span-1" }
const _hoisted_13 = { class: "font-medium" }
const _hoisted_14 = { class: "col-span-1" }
const _hoisted_15 = { class: "col-span-1" }

import { // store
		localesStore
	} from '@/store/locales'

	
	const __default__ = { name: 'JobIntroductions' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

return (_ctx: any,_cache: any) => {
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_data_display, null, {
        custom: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.introductions}])
          }, [
            (__props.job?.fieldData?.introductions)
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5"
                })),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(store).getLabel('347')), 1)
          ], 2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_data_display, null, {
        custom: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.introductions_participate}])
          }, [
            (__props.job?.fieldData?.introductions_participate)
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5"
                })),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(store).getLabel('348')), 1)
          ], 2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('240'),
        value: __props.job?.fieldData?.introductions_groom || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('346'),
        value: __props.job?.fieldData?.representative_groom_eng || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('241'),
        value: __props.job?.fieldData?.introductions_bride || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('346'),
        value: __props.job?.fieldData?.representative_bride_eng || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_data_display, null, {
        custom: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.firstMeet}])
          }, [
            (__props.job?.fieldData?.firstMeet)
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5"
                })),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(store).getLabel('809')), 1)
          ], 2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_data_display, null, {
        custom: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.familyMeet}])
          }, [
            (__props.job?.fieldData?.familyMeet)
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5"
                })),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(store).getLabel('810')), 1)
          ], 2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('332'),
        value: _ctx.$filters.hour24Time(__props.job?.fieldData?.timeFirstTime) || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('332'),
        value: _ctx.$filters.hour24Time(__props.job?.fieldData?.timeFamilyTime) || '—'
      }, null, 8, ["loading", "label", "value"])
    ])
  ]))
}
}

})